import React from 'react';
import PropTypes from 'prop-types';
import css from './Table.module.scss';
import {useTableContext} from './TableContext';

const TableCell = ({
  children,
  className = '',
  colSpan,
  rowSpan,
  align,
  style
  }) => {
  const {cellAlign} = useTableContext();
  const finalAlign = align ?? cellAlign ?? 'left';

  return (
    <td
      className={`${css.td} ${className}`.trim()}
      style={{textAlign: finalAlign, ...style}}
      colSpan={colSpan}
      rowSpan={rowSpan}
    >
      {children}
    </td>
  );
};

TableCell.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  colSpan: PropTypes.number,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  style: PropTypes.object
};

export default TableCell;
